export default class User {

    constructor(id, name, username, email, password){
        this.id = id;
        this.name = name;
        this.username = username;
        this.email = email;
        this.password = password;
    }

    getId(){
        return this.id;
    }

    getName(){
        return this.name;
    }

    getUsername(){
        return this.username;
    }

    getEmail(){
        return this.email;
    }

    getPassword(){
        return this.password;
    }

    setId(id){
        this.id = id;
    }

    setName(name){
        this.name = name;
    }

    setUsername(username){
        this.username = username;
    }

    setEmail(email){
        this.email = email;
    }

    setPassword(password){
        this.password = password;
    }
}